import { render, staticRenderFns } from "./InstructorResults.vue?vue&type=template&id=a864de26&"
import script from "./InstructorResults.vue?vue&type=script&lang=js&"
export * from "./InstructorResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports